<template>
  <div class="schedule max-content">
    <top :title="nav_title" :color="color"></top>
    <van-search v-model="keywords" placeholder="请输入搜索关键词" @search="onSearch" shape="round" background="#f7f7f7">
      <template #right-icon>
        <div @click="onSearch" class="search-icon">搜索</div>
      </template>
    </van-search>
    <div class="empty" v-if="scheduleList.length == 0">
      <img src="@/assets/images/System/no_meeting.png" />
      <p>暂无符合条件的日程</p>
    </div>
    <div v-else class="list">
      <div v-for="item in scheduleList" :key="item.id" class="item" @click="goDetail(item.parallel_session_id, item.id)">
        <p class="name">{{ item.name }}</p>
        <p v-if="item.start_at">开始时间：{{ item.start_at.substring(0, 16) }}</p>
        <p v-if="item.parallel_session">会场：{{ item.parallel_session.name }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { ButtonDetail, searchSchedule } from "../../../config/interface.js";
import Top from "../components/Top";

export default {
  components: {
    Top
  },
  data() {
    return {
      meeting_id: 0,
      button_id: this.$route.query.button_id ? this.$route.query.button_id : this.$route.query.b_id,
      scheduleList: [], //日期对应的日程列表
      keywords: '',
      nav_title: '日程一览',
      color: ""
    }
  },
  mounted() {
    this.meeting_id = this.$route.query.id;
    this.keywords = this.$route.query.keywords ? this.$route.query.keywords : ''
    this.getButtonData();
    this.onSearch()
  },
  methods: {
    //获取按钮信息
    getButtonData() {
      if (this.button_id) {
        const url = ButtonDetail;
        let params = {
          button_id: this.button_id
        }
        const method = "POST";
        fetch(url, params, method)
          .then((res) => {
            if (res.code == 0) {
              this.nav_title = res.data.name
              if (res.data.theme_color_hex) {
                this.color = res.data.theme_color_hex
              } else {
                this.color = '#901D22'
              }
            }
          })
      }else{

      }
    },
    onSearch() {
      if (this.keywords) {
        const url = searchSchedule;
        let params = {
          meeting_id: this.meeting_id,
          keyword: this.keywords
        }
        const method = "POST";
        fetch(url, params, method)
          .then((res) => {
            if (res.code == 0) {
              this.scheduleList = res.data;
            }
          })
      }
    },
    goDetail(parallel_session_id, id) {
      this.$router.push({
        path: '/vascularNews/meeting/liveDetail',
        query: { meeting_id: this.meeting_id, id: parallel_session_id, chapter_id: id }

      })
    }
  },
};
</script>
<style lang="scss" scoped>
.schedule {
  .van-search /deep/.van-field__right-icon {
    color: #666666;
    background: #EBEBEB;
    border-radius: 15px;
    margin-right: 5px;
    width: 60px;
    text-align: center;
  }

  .empty {
    text-align: center;
    padding-top: 80px;
    color: #999999;
    font-size: 14px;

    img {
      width: 40%;
      margin-bottom: 20px;
    }
  }

  .list {
    padding: 0 15px;

    .item {
      background: white;
      font-size: 12px;
      color: #666666;
      line-height: 20px;
      border-radius: 10px;
      margin-bottom: 15px;
      padding: 15px;

      .name {
        font-size: 16px;
        color: #1C1C1C;
        line-height: 22px;
        margin-bottom: 5px;
      }
    }
  }
}

.van-search__content {
  background: white;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting/ScheduleResult.vue